<template>
  <div class="add-rink">
    <form @submit.prevent="addRink">
      <modal-card>
        <div>
          <h1>Ajouter une patinoire</h1>

          <md-field>
            <label>Nom de la patinoire</label>
            <md-input v-model="name" required></md-input>
          </md-field>

          <md-field>
            <label for="description">Description</label>
            <md-select v-model="description" id="description">
              <md-option value="">Sélectionner...</md-option>
              <md-option value="Patinoire avec bandes"
                >Patinoire avec bandes</md-option
              >
              <md-option value="Patinoire de patin libre"
                >Patinoire de patin libre</md-option
              >
              <md-option value="Patinoire réfrigérée"
                >Patinoire réfrigérée</md-option
              >
              <md-option value="Patinoire extérieure"
                >Patinoire extérieure</md-option
              >
              <md-option value="Patinoire décorative"
                >Patinoire décorative</md-option
              >
              <md-option value="Sentier de glace">Sentier de glace</md-option>
              <md-option value="Rond de glace">Rond de glace</md-option>
              <md-option value="Aire de patinage libre"
                >Aire de patinage libre</md-option
              >
            </md-select>
          </md-field>

          <div class="md-layout md-gutter">
            <div class="md-layout-item">
              <md-field>
                <label>Adresse</label>
                <md-input v-model="addressInput" required></md-input>
              </md-field>
            </div>
            <div>
              <md-button
                class="md-icon-button md-raised md-primary"
                @click="searchCoords"
              >
                <md-icon>search</md-icon>
              </md-button>
            </div>
          </div>

          <md-progress-bar
            md-mode="indeterminate"
            v-show="searchLoading"
          ></md-progress-bar>

          <md-field>
            <label>Adresse trouvée</label>
            <md-input v-model="address" disabled required></md-input>
          </md-field>

          <div class="md-layout md-gutter">
            <div class="md-layout-item md-size-50">
              <md-field>
                <label>Lat</label>
                <md-input v-model="lat" disabled required></md-input>
              </md-field>
            </div>
            <div class="md-layout-item md-size-50">
              <md-field>
                <label>Lng</label>
                <md-input v-model="lng" disabled required></md-input>
              </md-field>
            </div>
          </div>
        </div>

        <template v-slot:actions>
          <md-button
            type="submit"
            class="md-fab md-mini md-primary button-right"
          >
            <md-icon>save</md-icon>
          </md-button>
        </template>
      </modal-card>
    </form>
  </div>
</template>

<style scoped>
.add-rink {
  font-family: "Montserrat", sans-serif;
}

h1 {
  font-family: "Staatliches", cursive;
  font-size: 4em;
  line-height: 0.9em;
  margin: 0;
}
h2 {
  font-family: "Montserrat", sans-serif;
  font-size: 1em;
}
a {
  color: #000 !important;
  font-weight: bold;
  font-family: "Staatliches", cursive;
  font-size: 1.4em;
}

.add-rink-dialog {
  padding: 10px;
  overflow-y: scroll;
}
</style>

<script>
import firebase from "firebase/app";
import dayjs from "dayjs";
import ModalCard from "../components/ModalCard";

export default {
  name: "add-rink",
  head: {
    title: {
      inner: "Ajouter une patinoire"
    },
    link: [{ rel: "canonical", href: "https://patinoires.ca/ajouter" }]
  },
  components: {
    ModalCard
  },
  data: () => ({
    searchLoading: false,
    name: "",
    description: "",
    addressInput: "",
    address: null,
    lat: null,
    lng: null
  }),
  methods: {
    addRink() {
      let obj = {};
      obj.name = this.name;
      obj.description = this.description;
      obj.addressInput = this.addressInput;
      obj.address = this.address;
      obj.lat = this.lat;
      obj.lng = this.lng;
      obj.timestamp = dayjs().toISOString();
      obj.uid = firebase.auth().currentUser.uid;
      firebase
        .database()
        .ref("/new-rinks/")
        .push(obj);

      this.$router.push("/");
    },
    resetCoords() {
      this.address = null;
      this.lat = null;
      this.lng = null;
    },
    async searchCoords() {
      this.searchLoading = true;
      this.resetCoords();
      let API_KEY = process.env.VUE_APP_GOOGLE_MAPS_GEOCODING_API_KEY;
      let address = this.addressInput;
      let response = await fetch(
        `https://maps.googleapis.com/maps/api/geocode/json?address=${address}&key=${API_KEY}`
      );
      let json = await response.json();
      if (json.results.length > 0) {
        let addressObj = json.results[0];
        this.address = addressObj.formatted_address;
        this.lat = addressObj.geometry.location.lat;
        this.lng = addressObj.geometry.location.lng;
      }
      this.searchLoading = false;
    }
  }
};
</script>
